export default "__VITE_ASSET__DvvS9ydP__"